import PropTypes from 'prop-types';
export * from './structure';
export * from './header';

export const GA_TRACKING_EVENT_CATEGORY = 'create-event';
export const ACTION_EVENT_PUBLISH = 'EventPublished';
export const LABEL_NEW_CREATE = 'coyote';

export const GA_GOAL_CATEGORY = 'goal';
export const ACTION_PUBLISH = 'Publish';
export const ACTION_INCREMENTAL_PUBLISH = 'IncrementalPublish';
export const ACTION_FIRST_PUBLISH = 'FirstPublish';
export const ACTION_FIRST_PAID_PUBLISH = 'FirstPaidPublish';
export const ACTION_FIRST_COYOTE_PUBLISH = 'FirstCoyotePublish';
export const ACTION_FIRST_COYOTE_PAID_PUBLISH = 'FirstCoyotePaidPublish';
export const ACTION_EVENT_PREVIEW = 'EventPreview';
export const GA_EVENT_PUBLISHED = 'EventPublished';

// Marketing Tools Experiment
export const VARIANT_A = 'A';

export const EVENT_SALES_STATUS_PROPTYPE = PropTypes.shape({
    salesStatusCode: PropTypes.string,
    salesStatusMessage: PropTypes.string,
    salesStatusMessageType: PropTypes.string,
    salesStatusMessageCode: PropTypes.string,
    isNotYetOnSale: PropTypes.bool,
    isOnSale: PropTypes.bool,
    isSoldOut: PropTypes.bool,
    salesStartDate: PropTypes.shape({
        utc: PropTypes.datetime,
        local: PropTypes.datetime,
        timezone: PropTypes.string,
    }),
});

export const EVENT_DASHBOARD_BASE = '/myevent';
